import { hero, about, socials } from "../data/site";

const Hero = () => {
  const h = hero;
  return (
    <section className="hero" id="top">
      <div className="hero-photo">
        <img src={h.photo} alt="Megholova, traveling" />
        <span className="hero-photo-tag">{h.photoTag}</span>
        <span className="hero-photo-place">
          <span className="pl-i">{h.photoPlace}</span>
          <span className="pl-c">{h.photoCoord}</span>
        </span>
      </div>
      <div className="hero-panel">
        <div className="hero-kicker">{h.kicker}</div>
        <h1 className="hero-h1">
          {h.headline[0]}<em>{h.headline[1]}</em><br />
          {h.headline[2]}<br />
          <span className="muted">{h.headline[3]}</span>
        </h1>
        <p className="hero-lead">{h.lead}</p>
        <div className="hero-foot">
          <img className="hero-ava" src={about.portrait} alt="Megholova" />
          <div className="hero-foot-id">
            <div className="nm">Megholova</div>
            <div className="rl">Software Engineer</div>
          </div>
          <div className="hero-foot-links">
            <a href={socials[1].link} target="_blank" rel="noreferrer">LinkedIn</a>
            <a href={socials[2].link} target="_blank" rel="noreferrer">GitHub</a>
            <a href={socials[3].link} target="_blank" rel="noreferrer">Medium</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
